import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import ListResponse from './listResponse';

const c = initContract();

export const Invite = z.object({
  email: z.string(),
  id: z.string(),
  redeemed: z.boolean()
});

export const InviteStatus = z.object({
  id: z.string(),
  redeemed: z.boolean()
});

export default c.router({
  getInvites: {
    method: 'GET',
    path: '/partners/:partnerId/companies/:companyId/invites',
    responses: {
      200: z.array(Invite)
    },
    summary: 'Get all invites for a company'
  },
  getInviteStatus: {
    method: 'GET',
    path: '/invites/:id',
    responses: {
      200: InviteStatus
    },
    summary: 'Get invite status'
  },
  inviteToPartner: {
    method: 'POST',
    path: '/partners/:partnerId/invites',
    responses: {
      200: Invite
    },
    body: z.object({
      email: z.string()
    }),
    summary: 'Invite a user to a partner'
  },
  inviteToCompany: {
    method: 'POST',
    path: '/partners/:partnerId/companies/:companyId/invites',
    responses: {
      200: Invite
    },
    body: z.object({
      email: z.string()
    }),
    summary: 'Invite a user to a company'
  },
  invitesToCompany: {
    method: 'POST',
    path: '/partners/:partnerId/companies/:companyId/invites/multi',
    responses: {
      200: ListResponse(Invite)
    },
    body: z.array(
      z.object({
        email: z.string()
      })
    ),
    summary: 'Invite users to a company'
  },
  inviteAsAdmin: {
    method: 'POST',
    path: '/adminInvites',
    responses: {
      200: Invite
    },
    body: z.object({
      email: z.string()
    }),
    summary: 'Invite a user as an admin'
  },
  inviteCreditChecker: {
    method: 'POST',
    path: '/creditcheckers/:creditCheckerId/invites',
    responses: {
      200: Invite
    },
    body: z.object({
      email: z.string()
    })
  }
});
